import React from 'react';
import PropTypes from 'prop-types';
import { FormHelperText } from '@material-ui/core';

const HelperText = ({ error, helperText }) => (error && helperText ? <FormHelperText>{helperText}</FormHelperText> : null);

HelperText.propTypes = {
    error: PropTypes.bool,
    helperText: PropTypes.string,
};

HelperText.defaultProps = {
    error: false,
    helperText: '',
};

export default HelperText;
